import { makeVar } from '@apollo/client';

export const isSearchingPatient = makeVar(false);
